export default __webpack_public_path__ + "static/media/promotions-pic-1.18110389.jpg";